import { get } from '../../utils/networking'

export const GET_PAGE = "GET_PAGE"
export const GET_PAGE_SUCCESS = "GET_PAGE_SUCCESS"
export const GET_PAGE_FAIL = "GET_PAGE_FAIL"

export const requestPage = () => {
    return {
        type: GET_PAGE
    }

}

export const requestPageSuccess = (result) => {
    return {
        type: GET_PAGE_SUCCESS,
        payload: result
    }

}

export const requestPageFail = () => {
    return {
        type: GET_PAGE_FAIL
    }
}

export const getPage = (slug) => {
    return dispatch => {
        dispatch(requestPage())

        get('page/' + slug, "", result => {
            dispatch(requestPageSuccess(result))
        }, errors => {
            dispatch(requestPageFail())
        })
    }
}


// WEBPACK FOOTER //
// ./src/components/page/action.js